// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PZoomInOutlinedSvg from "@fishx/icons-svg/es/asn/PZoomInOutlined";
import FishxIcon from '../components/FishxIcon';

var PZoomInOutlined = function PZoomInOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PZoomInOutlinedSvg
  }));
};

PZoomInOutlined.displayName = 'PZoomInOutlined';
export default React.forwardRef(PZoomInOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PZoomInOutlined.js
// module id = 3746
// module chunks = 0